<template>
  <div>
    <el-drawer @reload="$reloadHandle"
               title="抽样确定" size="30%"
               :before-close="handleClose"
               :visible.sync="drawer"
               direction="rtl"
               :modal-append-to-body="true"
               custom-class="demo-drawer"
               ref="drawer"
    >

      <div class="demo-drawer__content">
        <el-form :model="formData">
          <el-form-item   :readonly="true">
            <span class="title1">总样本数:</span>  <el-input v-model="formData.numuber" style="width: 150px;" :readonly="true"/>
          </el-form-item>
          <el-form-item>
            <span class="title1">回访率:</span><el-input v-model="formData.t" disabled="true" style="width: 150px;" :readonly="true"/>
          </el-form-item>

          <el-form-item >
            <span class="title1">回访量:</span> <el-input v-model="formData.numuber" disabled="true" style="width: 150px;" :readonly="true"/>
          </el-form-item>
          <el-form-item>
            <span class="title1"><em class="f-red">*</em>要求完成回访时间:</span>
            <el-date-picker
      v-model="formData.value1"
      style="width: 150px;"
      type="datetime"
      placeholder="选择日期时间">
    </el-date-picker>
          </el-form-item>
          <el-form-item   :readonly="true">
            <span class="title1"><em class="f-red">*</em>指定回访员:</span>  <el-input v-model="formData.recallManName" style="width: 150px;" :readonly="true">
              <i slot="suffix" class="el-input__icon el-icon-search" @click="showSitePop=true" ></i>
            </el-input>
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer" style="position: absolute; bottom: 5px; right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="auditBill">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

    <duDialog :param="this.type" v-if="showSitePop"
              @commitAdminRow="commitAdminRow"
              :visiable.sync="showSitePop" :roleCode="formData.roleCode"
              :unVisitSearch="formData.unVisitSearch"
              multi="true"/>

  </div>
</template>
<script>
import store from "@/store";
import api from "@/api/projectApi";
import duDialog from "@/views/dialogCommon/adminDialogByRole.vue";
import {echoFileFormat, uploadFileFormat} from "@/util/uploadFormat";
import orderPop from "@/views/dialogCommon/radioOrderDialog.vue";

export default {
  inject: ['reload'],
  name: 'edit',
  props: {
    ids: {
      type: Array,
      required: true
    }
  },

  created() {
    this.formData.id = this.dataId
    this.idsLength()
  },
  mounted() {
    // this.getData()
  },
  components: {duDialog},
  computed: {
    api() {
      return api
    },
    idsLength() {
      this.formData.numuber =  this.ids.length;
      this.formData.ids = this.ids;
    },

    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      }
    },
  },
  watch: {
    // 'formData.adjustAmount': {
    //   handler(n) {
    //     if (!isNaN(n)) {
    //       let number = Number(this.formData.adjustAmount) + Number(this.formData.standardAmount);
    //       this.formData.checkAmount = Math.round(number * 100) / 100
    //     }
    //   },
    //   deep: true
    // }
  },
  data() {
    return {
      type:null,
      showSitePop:false,
      formData: {
        numuber:0,
        remark: null,
        ids: null,
        value1: '',
        t:'100%',
        recallManId:null,
        recallManName:null,
        roleCode:'RECALL_USER',
        unVisitSearch:'true',
      },
      showOrderPop: false,

      drawer: true,


    }
  },
  methods: {

    //确定选择督办人
    commitAdminRow(data,type) {
      if(type==1) {
        this.formData.recallManId = data.id;
        this.formData.recallManName = data.name;
      }else {
        this.formData.recallManId = data.id;
        this.formData.recallManName = data.name;
      }
    },

    cancelForm() {
      this.loading = false;
      this.drawer = false;
      clearTimeout(this.timer);
    },
    handleClose() {

      this.drawer = false;
      this.$emit('closeD', false)
    },
    async auditBill(){
      console.log("样本池的ids为"+this.ids)
      console.log("这里拿到的回访要求完成时间为"+this.formData.value1)
      let datetime = new Date(this.formData.value1);
      let timezoneOffset = datetime.getTimezoneOffset() * 60000; // 获取当前时区与UTC的时间差（以毫秒为单位）
      let localDatetime = new Date(datetime - timezoneOffset); // 调整时间，得到当前时区时间
      let isoString = localDatetime.toISOString();
      try {
                   this.$mask.open()

        // 发送请求
        const res = await axios.post(api.visitProject.createRecall, {
          allOrders: this.formData.numuber,
          rate:1,
          recallOrders:this.formData.numuber,
          orderIds:this.formData.ids,
          recallFinishDate: isoString,
          issueManId:this.formData.recallManId,
          issueMan:this.formData.recallManName,
          stat:1,
          recallOrigin:1,
          successOrders:0,
          successRate:0,
          failOrders:0,
          failRate:0,
          recallRate:0,
        });
        if (res.data) {
          this.$message.success('操作成功！');
          this.reload()
        } else {
          this.$message.error('操作失败，请稍后重试');
        }
      } catch (error) {
        console.error(error);
        this.$message.error('系统错误，请稍后重试');
      } finally {
        this.$mask.close()

      }
      this.$mask.close()

    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

::v-deep .el-drawer__container {
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: aliceblue;
  background-color: rgb(38 38 38 / 70%);
}

#containt .table-detail {
  border-collapse: collapse;
  font-size: 12px;
  border: 1px solid #ededed;
}

.btn {
  text-align: center;
}

::v-deep .el-input-number [role=button] {
    line-height: 26px;
    height: 26px;
    margin-top: 40px;
}
.el-input-number--medium {
    width: 200px;
    display: block;
    line-height: 34px;
}
.title1{
  display: inline-block;
    width: 120px;
    color: #72767b;
    font-size: 13px;
    text-align: end;
    margin: 5px 10px;
}
</style>
